<template>
  <div class="wrapper">
    <div class="chart-wrapper">
      <PieChart :colors="colors" :data="data"></PieChart>
    </div>

    <div class="legends">
      <div class="legend" v-for="(item, index) in data" :key="index">
        <div class="title">
          <div class="box" :style="{ background: colors[index % colors.length] }"></div>
          {{ item.name }}
        </div>
        <div class="value">{{ Math.round(item.value * 100 * 10000) / 10000 }}%</div>
      </div>
    </div>
  </div>
</template>

<script>
import PieChart from "@/pages/H5/ResultEditor/components/InvoiceIndex/components/PieChart";

export default {
  props: {
    data: Array,
  },
  components: {
    PieChart,
  },
  data() {
    return {
      colors: [
        "#C41D1D",
        "#C47C1D",
        "#C4C11D",
        "#1DC424",
        "#1D73C4",
        "#541DC4",
        "#599EF7",
        "#59F78C",
        "#F7A659",
        "#F75959",
        "#000000",
      ],
    };
  },
  computed: {
    chartData() {
      const ret = [];
      for (const i in this.data.xLabels) {
        const label = this.data.xLabels[i];
        const value = this.data.series[0].data[i];

        ret.push({ name: label, value });
      }
      return ret;
    },
  },
};
</script>

<style lang="stylus" scoped>
.wrapper {
  display: flex;
  flex-direction: column;
  align-content: center;

  .chart-wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
    align-content: center;
  }

  .legends {
    flex-shrink: 0;
    flex-grow: 1;
    display: flex;
    flex-direction: column;
    justify-content: center;
    margin-left: 20px;

    .legend {
      width: 5.64rem;
      color: #666;
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 0.2rem;
      font-size: 0.24rem;

      .box {
        display: inline-block;
        width: 0.2rem;
        height: 0.2rem;
        background: red;
        margin-right: 0.1rem;
      }

      .title {
        display: flex;
        align-items: center;
      }

      .value {
        // vertical-align: top;
      }
    }
  }
}
</style>
